import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./utils/serviceWorker";
import { I18nextProvider } from "react-i18next";
import i18n from './i18n';

if (process.env.NODE_ENV === 'development') {
    const { worker } = require('./mocks/browser')
    worker.start()
}

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <App />
    </I18nextProvider>, 
    document.getElementById("root")
);

serviceWorker.unregister();
